import { registerListResourceWithStore } from '@/services/GenericListResourceService'
import store from '@/store'

registerListResourceWithStore('departments', 'departments', store)
registerListResourceWithStore('orgUnits', 'orgunits', store)

registerListResourceWithStore('customFields', 'customfields', store, {
  getters: {
    sortedCustomFields: (state, getters, rootState, rootGetters) => getters.sortedItems(['appliesTo', 'sortOrder', 'name'])
      .filter(item =>
        item.active &&
        (!item.sensitive || rootGetters.canAccessEmployeeSensitive) &&
        (rootGetters.scheduleEnabled || item.appliesTo !== 'shift')
      ),
    punchCustomFields: (state, getters) =>
      getters.sortedCustomFields.filter(item => item.appliesTo === 'punch'),
    shiftCustomFields: (state, getters) =>
      getters.sortedCustomFields.filter(item => item.appliesTo === 'shift'),
    userCustomFields: (state, getters) =>
      getters.sortedCustomFields.filter(item => item.appliesTo === 'user'),
    workCustomFields: (state, getters) =>
      getters.sortedCustomFields.filter(item => ['punch', 'shift'].includes(item.appliesTo)),
    crossIndexCustomFields: (state, getters) => getters.userCustomFields.filter(item => item.crossIndex),
    // Cross indexing reports can display columns for all user custom fields except non-cross indexed choice fields,
    // because we don't have the custom field item names for them.
    supplementalUserCustomFields: (state, getters) => getters.userCustomFields.filter(item => item.crossIndex || item.type !== 'choice')
  }
})

export default {
  name: 'organization',
  label: 'Organization',
  link: 'organization',
  path: 'organization',
  props: true,
  icon: 'sitemap',
  description: 'Define your operational foundation and organization-wide standards.',
  component: () => import('@/components/TabPanel.vue'),
  requirePerm: 'edit_settings',
  breadcrumbLeaf: true,
  children: [
    {
      name: 'org-defaults',
      navLabel: 'Organization Defaults',
      navIcon: 'SlidersHorizontal',
      label: 'Defaults',
      icon: 'sliders',
      title: 'Org Defaults',
      path: 'defaults',
      component: () => import('./OrgDefaultsForm.vue')
      .catch(error => {
        console.error('Failed to route to OrgDefaultsForm', error)
        throw error
      })
    },
    {
      name: 'org-formats',
      navLabel: 'Organization Formats',
      navIcon: 'Globe',
      label: 'Formats',
      icon: 'globe',
      title: 'Org Formats',
      path: 'formats',
      props: true,
      component: () => import('./OrgFormatsForm.vue')
    },
    {
      name: 'customfields',
      navIcon: 'ListPlus',
      label: 'Custom Fields',
      icon: 'list-ul',
      path: 'customfields/:view?',
      requireGetter: 'hasCustomFieldFeature',
      requirePerm: 'edit_settings',
      component: () => import('@/modules/organization/customfields/CustomFieldList.vue')
        .catch(error => {
          console.error('Failed to route to CustomFieldList', error)
          throw error
        })
    },
    {
      name: 'department-list',
      navIcon: 'Building2',
      label: 'Departments',
      icon: 'briefcase',
      path: 'departments/:view?',
      props: true,
      component: () => import('./DepartmentList.vue')
        .catch(error => {
          console.error('Failed to route to DepartmentList', error)
          throw error
        })
    },
    {
      name: 'label-list',
      navIcon: 'Tags',
      label: 'Labels',
      icon: 'tags',
      path: 'labels/:view?',
      props: true,
      component: () => import('./LabelList.vue')
    },
    {
      name: 'org-unit-list',
      navIcon: 'Network',
      label: 'Org Units',
      icon: 'building',
      path: 'orgunits/:view?',
      props: true,
      component: () => import('./OrgUnitList.vue')
    },
    {
      name: 'organization-index',
      path: '',
      redirect: { name: 'org-defaults' }
    }
  ]
}
